module.exports = __webpack_public_path__ + "pc/img/logo1.ec10715b.png";